<template>
    <div class="section-tiles" :class="color">
        <layout-contained :class="padding">
            <div class="flex justify-between">
                <content-heading
                    v-if="heading"
                    :heading="heading"
                    :headingColor="headingColor"
                    :headingComponent="headingComponent"
                    :textCentered="textCentered"
                ></content-heading>
                <div v-if="buttonText" :class="!!textCentered ? 'text-center' : ''">
                    <button-heading
                        class="-mt-2"
                        :buttonColor="buttonColor || undefined"
                        :buttonRoute="buttonRoute"
                        :buttonText="buttonText"
                        :buttonClick="buttonClick"
                        :buttonClickParams="buttonClickParams"
                    ></button-heading>
                </div>
            </div>
            <content-text
                v-if="content"
                :html="content"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></content-text>
            <layout-tiles
                v-if="tiles && tiles.length"
                :class="heading || content ? 'mt-5 sm:mt-8' : ''"
                :dividerColor="dividerColor"
            >
                <layout-tile
                    v-for="(tile, index) in tiles"
                    :key="'section-tiles-tile-' + index"
                    :color="tileColor"
                    :url="tile.url"
                    :route="tile.route"
                    :image="tile.image"
                    :heading="tile.heading"
                    :excerpt="tile.excerpt"
                ></layout-tile>
            </layout-tiles>
            <slot name="custom"></slot>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionTiles',
    props: {
        tiles: {
            required: false,
            type: Array,
            default() {
                return [];
            },
        },
        padding: {
            required: false,
            default: 'pt-10 sm:pt-14 pb-12 sm:pb-16',
            type: String,
        },
        buttonColor: {
            required: false,
            type: String,
            default: null,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-100',
        },
        tileColor: {
            required: false,
            type: String,
            default: 'bg-white hover:bg-zinc-50',
        },
        dividerColor: {
            required: false,
            type: String,
            default: 'divide-gray-100',
        },
        content: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
};
</script>
